export enum FlowType {
  User,
  Lender,
  Edit,
}
